/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import moment from 'moment'
import _ from 'lodash'
// import {privateApi, publicApi} from 'utils/api'

export const timeConvert = (n: number) => {
    const num = n
    const hours = num / 60
    const rhours = Math.floor(hours)
    const minutes = (hours - rhours) * 60
    const rminutes = Math.round(minutes)
    return `${rhours}hr ${rminutes}m`
}

export const getTodayDate = () => {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')

    return `${year}-${month}-${day} ${hours}:${minutes}`
}

export const getTodayDateDDMMMYY = () => moment().format('DDMMMYY').toUpperCase()

export const getDateDDMMMYY = (date) => moment(date).format('DDMMMYY').toUpperCase()

export const getFormattedDate = (date, format) => moment(date).format(format).toUpperCase()

export const getPastDateDDMMMYY = (pastDays: number) => {
    const monthsShort = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    const date = new Date()
    const pastDate = new Date(date.getTime() - pastDays * 24 * 60 * 60 * 1000)
    const pastMonth = monthsShort[pastDate.getMonth()]
    const pastDay = String(pastDate.getDate()).padStart(2, '0')
    const pastYear = String(pastDate.getFullYear()).slice(-2)
    return `${pastDay}${pastMonth}${pastYear}`
}

const formatDateTime = (date: string, time: string) => {
    const temp: string = `${time.slice(0, 2)}:${time.slice(2)}`
    return Date.parse(`${date}' '${temp}`)
}

export const sortByArrival = (a: any, b: any) => {
    const aLength = Object.keys(a.seg).length - 1
    const bLength = Object.keys(b.seg).length - 1
    const arr1 = formatDateTime(a.seg[aLength].fltInfo.arrival.date, a.seg[aLength].fltInfo.arrival.time)
    const arr2 = formatDateTime(b.seg[bLength].fltInfo.arrival.date, b.seg[bLength].fltInfo.arrival.time)
    if (arr1 < arr2) {
        return -1
    } else if (arr1 === arr2) {
        const dep1 = formatDateTime(a.seg[0].fltInfo.departure.date, a.seg[0].fltInfo.departure.time)
        const dep2 = formatDateTime(b.seg[0].fltInfo.departure.date, b.seg[0].fltInfo.departure.time)
        if (dep1 < dep2) {
            return -1
        } else if (dep1 === dep2) {
            const rate1: number = parseFloat(_.get(a, 'productDetails.charges.rates.actual', '0.0'))
            const rate2: number = parseFloat(_.get(b, 'productDetails.charges.rates.actual', '0.0'))
            if (rate1 === rate2) {
                return 0
            } else {
                return rate1 - rate2
            }
        } else {
            return 1
        }
    }
    return 1
}

export const sortByDeparture = (a: any, b: any) => {
    const arr1 = formatDateTime(a.seg[0].fltInfo.departure.date, a.seg[0].fltInfo.departure.time)
    const arr2 = formatDateTime(b.seg[0].fltInfo.departure.date, b.seg[0].fltInfo.departure.time)
    if (arr1 < arr2) {
        return -1
    } else if (arr1 === arr2) {
        const aLength = Object.keys(a.seg).length - 1
        const bLength = Object.keys(b.seg).length - 1
        const dep1 = formatDateTime(a.seg[aLength].fltInfo.arrival.date, a.seg[aLength].fltInfo.arrival.time)
        const dep2 = formatDateTime(b.seg[bLength].fltInfo.arrival.date, b.seg[bLength].fltInfo.arrival.time)
        if (dep1 < dep2) {
            return -1
        } else if (dep1 === dep2) {
            const rate1: number = parseFloat(_.get(a, 'productDetails.charges.rates.actual', '0.0'))
            const rate2: number = parseFloat(_.get(b, 'productDetails.charges.rates.actual', '0.0'))
            if (rate1 === rate2) {
                return 0
            } else {
                return rate1 - rate2
            }
        } else {
            return 1
        }
    }
    return 1
}

export const sortByRate = (a: any, b: any) => {
    const rate1: number = parseFloat(a.productDetails.charges.rates.actual)
    const rate2: number = parseFloat(b.productDetails.charges.rates.actual)
    if (rate1 === rate2) {
        return sortByArrival(a, b)
    } else {
        return rate1 - rate2
    }
}

export const sortForBest = (a: any, b: any) => {
    const stops1: number = Object.keys(a.seg).length - 1
    const stops2: number = Object.keys(b.seg).length - 1
    const journeyTime1 = parseInt(a?.Duration)
    const journeyTime2 = parseInt(b?.Duration)
    const rate1 = parseFloat(a.productDetails.charges.rates.actual)
    const rate2 = parseFloat(b.productDetails.charges.rates.actual)
    const aLength = Object.keys(a.seg).length - 1
    const bLength = Object.keys(b.seg).length - 1
    const arrival1 = formatDateTime(a.seg[aLength].fltInfo.arrival.date, a.seg[aLength].fltInfo.arrival.time)
    const arrival2 = formatDateTime(b.seg[bLength].fltInfo.arrival.date, b.seg[bLength].fltInfo.arrival.time)
    const dep1 = formatDateTime(a.seg[0].fltInfo.departure.date, a.seg[0].fltInfo.departure.time)
    const dep2 = formatDateTime(b.seg[0].fltInfo.departure.date, b.seg[0].fltInfo.departure.time)

    return stops1 - stops2 || rate1 - rate2 || journeyTime1 - journeyTime2 || arrival1 - arrival2 || dep1 - dep2
}

export const userIdValidation = (value: string) => {
    const regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i
    const payloadValues = {
        email: null,
        userID: null
    }
    if (regex.test(value)) {
        // eslint-disable-next-line object-curly-spacing
        return {...payloadValues, email: value}
    } else {
        // eslint-disable-next-line object-curly-spacing
        return {...payloadValues, userID: value}
    }
}

export const arraySorter = (data: any, key: string, sortType: string) =>
    sortType === 'desc'
        ? data?.slice().sort((a, b) => (+a[key] < +b[key] ? 1 : +b[key] < +a[key] ? -1 : 0))
        : data?.slice().sort((a, b) => (+a[key] > +b[key] ? 1 : +b[key] > +a[key] ? -1 : 0))

export const transformData = (jsonData: any) => {
    let addDataKey
    if (jsonData !== undefined) {
        const response = jsonData?.map((item: any) => ({
            x: item.eventDate,
            y: item.value
        }))
        if (jsonData.length > 1 && jsonData.length <= 4) {
            const nextEventDate = new Date(response[jsonData?.length - 1]?.x)
            nextEventDate.setDate(nextEventDate.getDate() + 1)
            const newObject = {
                x: nextEventDate.toISOString().split('T')[0]
            }
            response.push(newObject)
        } else {
            addDataKey = [{id: 'point of sales', data: response}]
        }
        addDataKey = [{id: 'point of sales', data: response.slice()}]
    }
    return addDataKey
}

export const dataConvertDomesticInternationalChart = (data: any, totalValue: any) => {
    const response = data?.map((item: any, index: any) => {
        const percentageType = item?.intl === false ? 'Domestic' : 'International'
        const percentageValue = (item?.value * 100) / totalValue
        return {
            id: item?.intl === false ? 'Domestic' : 'International',
            label: item?.intl === false ? 'Domestic' : 'International',
            valueType: item?.valueType === 'BookingCount' ? 'bookings' : item?.valueType,
            value: item?.value,
            unit: item?.unit,
            momData: item?.momData,
            yoyData: item?.yoyData,
            [percentageType]: {
                id: percentageType,
                percentage: Math.round(percentageValue * 100) / 100
            }
        }
    })
    const addDataKey = [{data: response}]
    return addDataKey
}

export const DateConverterWithComma = (data: any) => {
    const dateArr: any = data?.slice(4, 16).split(' ')
    dateArr[1] = ` ${dateArr[1]}, `
    return dateArr.join('')
}

export const kFormatter = (num: any) => {
    const absNum = Math.abs(num)
    let formattedValue

    if (absNum >= 1e6) {
        formattedValue = `${((Math.sign(num) * absNum) / 1e6).toFixed(1)}M`
    } else if (absNum >= 1e3) {
        formattedValue = `${((Math.sign(num) * absNum) / 1e3).toFixed(1)}k`
    } else {
        formattedValue = (Math.sign(num) * absNum).toFixed(absNum % 1 !== 0 ? 2 : 0)
        return formattedValue.includes('.') ? formattedValue.replace(/\.?0+$/, '') : formattedValue
    }

    return formattedValue
}

export const getDateYYYYMMDD = (date) => moment(date).format('YYYY-MM-DD')

export const commaDelimiterInNumbers = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const getMaxVal = (maxValue) => {
    switch (true) {
        case maxValue < 0.1:
            return 0.1
        case maxValue < 0.5:
            return 0.4
        case maxValue < 0.9:
            return 1
        case maxValue < 2:
            return 2
        case maxValue < 3:
            return 3
        case maxValue < 4:
            return 4
        case maxValue < 5:
            return 5
        case maxValue < 6:
            return 6
        case maxValue < 7:
            return 7
        case maxValue < 8:
            return 8
        case maxValue < 9:
            return 9
        case maxValue < 10:
            return 10
        case maxValue < 15:
            return 15
        case maxValue < 20:
            return 20
        case maxValue < 30:
            return 30
        case maxValue < 40:
            return 40
        case maxValue < 50:
            return 50
        case maxValue < 60:
            return 60
        case maxValue < 70:
            return 70
        case maxValue < 80:
            return 80
        case maxValue < 90:
            return 90
        case maxValue % 100 === 0:
            return maxValue
        default:
            return maxValue * 1.5
    }
}

export const numberDecimalFormatter = (number, numOfDecimals: number = 2) => {
    const hasDecimal = number % 1 !== 0
    return hasDecimal ? number.toFixed(numOfDecimals) : parseInt(number)
}

export const formatCountryDropdownValues = (arr) =>
    arr?.length > 0
        ? arr?.map((item) => ({
              value: item?.countryCode,
              label: item?.fullName
          }))
        : []

export const formatContinentDropdownValues = (arr) =>
    arr?.length > 0
        ? arr?.map((item) => ({
              value: item?.continentCode,
              label: item?.continentName
          }))
        : []

export const formatRegionDropdownValues = (arr) =>
    arr?.length > 0
        ? arr?.map((item) => ({
              value: item?.region,
              label: item?.region
          }))
        : []

export const convertToBoolean = (value: any) => {
    if (value === 'Y' || value === 'Enabled') return true
    else if (value === 'N' || value === 'Disabled') return false
    else return value // keep it unchanged if the value is neither "Y" nor "N" or "Enabled" nor "Disabled"
}

export const convertUserAccessLevelToBoolean = (userAccessLevels: any) => {
    if (typeof userAccessLevels === 'object' && userAccessLevels !== null) {
        for (const key in userAccessLevels) {
            if (Object.prototype.hasOwnProperty.call(userAccessLevels, key)) {
                userAccessLevels[key] = convertUserAccessLevelToBoolean(userAccessLevels[key])
            }
        }
        return userAccessLevels
    } else {
        return convertToBoolean(userAccessLevels)
    }
}
// calculate weight/volume in percentage using used and left value
export const calculatePercentage = (usedV = 0, leftV = 0) => {
    // converting to string even if it comes as number
    const resVal = Math.round((usedV / (usedV + leftV)) * 100)
    const checkIfNegetive = Math.sign(Math.round((usedV / (usedV + leftV)) * 100))
    if (resVal > 100 || checkIfNegetive === -1) {
        return 100
    } else {
        return resVal
    }
}

export const numberWithCommas = (x) => x?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')

export const roundWeightAndVolume = (value) => {
    if (isNaN(value)) {
        return 0
    } else {
        return numberWithCommas(value)
    }
}

export const valuesConverter = (data) =>
    data?.length > 0
        ? data?.map((item) => ({
              value: item,
              label: item
          }))
        : []

export const getCarrierstatus = (selectedCarrier) => {
    if (selectedCarrier === 'UA' || selectedCarrier === 'AA' || selectedCarrier === 'AF-KL') {
        return false
    } else return true
}

export const getUsedValues = (total, remaining) => {
    let usedValue: any = 0
    if (total && remaining) {
        usedValue = parseInt(total) - parseInt(remaining)
    }
    return usedValue
}

// export const getApiClient = () => {
//     const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
//     return isLoggedIn ? privateApi : publicApi
// }
